import React, { useState, useEffect } from 'react';
import { FiGithub, FiExternalLink, FiFolder } from 'react-icons/fi';
import './Projects.css';
import API_URL from '../config';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await fetch(`${API_URL}/profile/projects`);
        const data = await res.json();
        if (data.success) setProjects(data.data);
      } catch (error) {
        console.error('Failed to fetch projects');
      }
      setLoading(false);
    };
    fetchProjects();
  }, []);

  if (loading) {
    return (
      <section className="projects section">
        <div className="container">
          <div className="section-title"><h2>My Projects</h2></div>
          <p style={{ textAlign: 'center', color: 'var(--text-muted)' }}>Loading...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="projects section">
      <div className="container">
        <div className="section-title"><h2>My Projects</h2></div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={project._id || index} className={`project-card ${project.featured ? 'featured' : ''}`}>
              <div className="project-header">
                <FiFolder className="project-icon" />
                <div className="project-links">
                  {project.github && <a href={project.github} target="_blank" rel="noopener noreferrer"><FiGithub /></a>}
                  {project.live && <a href={project.live} target="_blank" rel="noopener noreferrer"><FiExternalLink /></a>}
                </div>
              </div>

              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>

                {project.features && project.features.length > 0 && (
                  <div className="project-features">
                    <h4>Features:</h4>
                    <ul>
                      {project.features.map((feature, idx) => <li key={idx}>{feature}</li>)}
                    </ul>
                  </div>
                )}
              </div>

              <div className="project-tech">
                {project.technologies?.map((tech, idx) => <span key={idx} className="tag">{tech}</span>)}
              </div>
            </div>
          ))}
        </div>

        <div className="more-projects">
          <p>More projects coming soon!</p>
          <a href="https://github.com/manishmandal55" target="_blank" rel="noopener noreferrer" className="btn btn-outline">
            <FiGithub /> View GitHub
          </a>
        </div>
      </div>
    </section>
  );
};

export default Projects;
